import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/siteData";

export default function Testimonials() {
    return (
        <section
            id="testimonials"
            data-testid="testimonials"
            className="relative py-24 md:py-32 bg-secondary/40"
        >
            <div className="max-w-7xl mx-auto px-5 md:px-8">
                <div className="max-w-2xl mb-14">
                    <div className="flex items-center gap-3 mb-5">
                        <span className="divider-gold" />
                        <span className="uppercase tracking-[0.28em] text-xs text-gold font-medium">
                            Testimonials
                        </span>
                    </div>
                    <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-tight">
                        Trusted by families, developers, and institutions.
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    {TESTIMONIALS.map((t, i) => (
                        <motion.figure
                            key={t.name}
                            data-testid={`testimonial-${i}`}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.5, delay: (i % 2) * 0.08 }}
                            className="relative p-8 md:p-10 rounded-2xl bg-card border hairline"
                        >
                            <Quote className="absolute top-6 right-6 h-6 w-6 text-gold/40" />
                            <div className="flex items-center gap-1 mb-4">
                                {Array.from({ length: 5 }).map((_, s) => (
                                    <Star
                                        key={s}
                                        className="h-4 w-4 fill-gold text-gold"
                                        strokeWidth={1.5}
                                    />
                                ))}
                            </div>
                            <blockquote className="font-display text-xl md:text-2xl leading-snug tracking-tight">
                                “{t.quote}”
                            </blockquote>
                            <figcaption className="mt-6 pt-6 border-t hairline">
                                <div className="font-medium">{t.name}</div>
                                <div className="text-xs uppercase tracking-widest text-muted-foreground">
                                    {t.role}
                                </div>
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
